import { useState } from 'react';
import { notesToSectionURL } from '../utils/ConstantsURL';
import { toastAlert } from '../utils/AlertContext';

export const useNotesToSection = () => {
  const [isAdding, setIsAdding] = useState(false);

  const addNotesToSection = async (
    id_documento,
    id_seccion,
    cvecapsulas, 
    token,
    fecha_transferencia
  ) => {
    console.log('🟦 useNotesToSection: Starting request...');
    setIsAdding(true);

    try {
      if (!id_documento || !id_seccion) {
        throw new Error('id_documento e id_seccion son requeridos para transferir las notas');
      }

      const requestData = {
        id_documentoTarget: id_documento.toString(),
        id_seccionTarget: id_seccion.toString(),
        cvecapsulas: cvecapsulas.map((cv) => cv.toString()),
        ...(fecha_transferencia && { fecha_transferencia }),
      };

      console.log('🟦 useNotesToSection: Request data:', requestData);

      const response = await fetch(notesToSectionURL(), {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      console.log('🟦 useNotesToSection: Response status:', response.status);

      if (!response.ok) {
        const errorData = await response.json();
        console.error('🟦 useNotesToSection: Error response:', errorData);
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('🟦 useNotesToSection: Success response:', data);

      const successCount = data.transferResults ? 
        data.transferResults.filter(result => result.success).length : 
        cvecapsulas.length;

      const failedCount = cvecapsulas.length - successCount;

      if (failedCount > 0) {
        toastAlert(
          `${successCount} notas agregadas exitosamente. ${failedCount} fallaron.`,
          'warning'
        );
      } else {
        toastAlert(
          `Notas insertadas de manera correcta`,
          'success'
        );
      }

      return { success: true, data, successCount, failedCount };
    } catch (error) {
      console.error('🟦 useNotesToSection: Error:', error);
      
      toastAlert(
        error.message || 'Error al agregar las notas a la sección',
        'error'
      );

      return { success: false, error: error.message };
    } finally {
      setIsAdding(false);
      console.log('🟦 useNotesToSection: Request completed');
    }
  };

  return { addNotesToSection, isAdding };
};

export default useNotesToSection;
